import axios from "../../axiosDod.js";
import { PANELS, PANEL_STORAGE_KEY } from "../../config/panels";

const setDODView = async ({ commit }, status) => {
  commit("SET_DOD_VIEW", status);
  if (status) {
    window.sessionStorage.setItem("seniorapp_dod_view", 1);
  } else {
    window.sessionStorage.setItem("seniorapp_dod_view", 0);
  }
};

// Ustawia aktywny panel (MAIN_APP|DOD|POD) i utrzymuje kompatybilnosc wsteczna z DODView/seniorapp_dod_view.
const setActivePanel = async ({ commit }, panel) => {
  commit("SET_ACTIVE_PANEL", panel);
  window.sessionStorage.setItem(PANEL_STORAGE_KEY, panel);
  const isDodOrPod = panel !== PANELS.MAIN_APP;
  commit("SET_DOD_VIEW", isDodOrPod);
  window.sessionStorage.setItem("seniorapp_dod_view", isDodOrPod ? 1 : 0);
};

const setDodAppSettingsByName = async ({ commit }, settings) => {
  const response = await axios.put(`/appSettings/${settings.id}`, {
    name: settings.name,
    value: settings.value,
  });
  commit("SET_DOD_APP_SETTINGS", response.data);
};

const fetchDodAppSettingsByName = async ({ commit }, name) => {
  const response = await axios.get(`/appSettings/name/${name}`);
  commit("SET_DOD_APP_SETTINGS", response.data);
};

export default {
  setDODView,
  setActivePanel,
  setDodAppSettingsByName,
  fetchDodAppSettingsByName,
};
